import utility from "core/Utils";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as BellIcon } from "../../images/bell.svg";
import { ReactComponent as SettingsIcon } from "../../images/settings.svg";
import localforage from "localforage";
import {
  LS_AUTH_TOKEN_KEY,
  LS_PRIMARY_COLOR,
  LS_REFRESH_TOKEN_KEY,
} from "core/Constants";

const Header = props => {
  const [userOptionOpened, setUserOptionOpened] = useState(false);
  const [colorSwatch, setColorSwatch] = useState("#ef5350");
  const navigate = useNavigate();

  const handleSwatchSwitch = color => {
    setColorSwatch(color);
    persistColorChange(color);
    document.documentElement.style.setProperty("--primary", color);
  };

  const persistColorChange = async color => {
    try {
      await localforage.setItem(LS_PRIMARY_COLOR, color);
    } catch (error) {
      console.error("Failed to persist color change");
    }
  };

  const getPrimaryColor = () => {
    return localforage.getItem(LS_PRIMARY_COLOR);
  };

  const setPrimaryColor = async () => {
    let color = "#ef5350";
    try {
      let c = await getPrimaryColor();
      if (c) {
        color = c;
      }
    } catch (error) {
      console.error("Failed to set primary color");
    }

    handleSwatchSwitch(color);
  };

  const logout = async () => {
    await localforage.removeItem(LS_AUTH_TOKEN_KEY);
    await localforage.removeItem(LS_REFRESH_TOKEN_KEY);
    navigate("/login");
  };

  useEffect(() => {
    setPrimaryColor();
  }, []);

  const user = props.client_name
    ? `${props.user} - ${props.client_name}`
    : props.user;

  return (
    <header>
      <div className="title-section">
        <h1>{props.title}</h1>
        <h4>Welcome, {user}</h4>
      </div>
      <div className="menu-section flex flex-center">{props.children}</div>
      <div className="option-section flex">
        {/* <div className="option text-center">
          <BellIcon />
        </div> */}
        <div
          className="option text-center user-option flex-center"
          onClick={_ => setUserOptionOpened(!userOptionOpened)}
        >
          <SettingsIcon />
          {userOptionOpened && (
            <div className="user-option-box">
              <div className="row" onClick={logout}>
                Logout
              </div>
              <div className="row flex flex-center swatch-options">
                <div
                  className={
                    colorSwatch === "#ef5350"
                      ? "color-swatch red active"
                      : "color-swatch red"
                  }
                  onClick={e => {
                    e.stopPropagation();
                    handleSwatchSwitch("#ef5350");
                  }}
                ></div>
                <div
                  className={
                    colorSwatch === "#42a5f5"
                      ? "color-swatch blue active"
                      : "color-swatch blue"
                  }
                  onClick={e => {
                    e.stopPropagation();
                    handleSwatchSwitch("#42a5f5");
                  }}
                ></div>
                <div
                  className={
                    colorSwatch === "#26B46C"
                      ? "color-swatch green active"
                      : "color-swatch green"
                  }
                  onClick={e => {
                    e.stopPropagation();
                    handleSwatchSwitch("#26B46C");
                  }}
                ></div>
                <div
                  className={
                    colorSwatch === "#FDBE0F"
                      ? "color-swatch yellow active"
                      : "color-swatch yellow"
                  }
                  onClick={e => {
                    e.stopPropagation();
                    handleSwatchSwitch("#FDBE0F");
                  }}
                ></div>
                <div
                  className={
                    colorSwatch === "#393939"
                      ? "color-swatch black active"
                      : "color-swatch black"
                  }
                  onClick={e => {
                    e.stopPropagation();
                    handleSwatchSwitch("#393939");
                  }}
                ></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
